<onep-pop-in-modal-title>Problème de connexion</onep-pop-in-modal-title>
<onep-pop-in-modal-content>
  Vous n'avez pas le droit d'accéder à ce portail avec ce profil.
</onep-pop-in-modal-content>
<onep-pop-in-modal-buttons>
  <button onepButton onepButtonType="primary" (click)="onRetryClick()">
    Réessayer
  </button>
</onep-pop-in-modal-buttons>
